import { t } from '@/i18n'
import React from 'react'
import styles from './InstallationsSummary.module.scss'
import { InstallationTypeEnum } from '@/generated'

interface Installation {
  name?: string
  price_without_vat?: string
  priceWithoutVat?: string
  installation_type?: string
  installationType?: string
  is_customer_paid?: boolean
  isCustomerPaid?: boolean
}

interface Props {
  installations: Installation[]
  isEditing?: boolean
  showManageButton?: boolean
  onManageClick?: () => void
  title?: string
}

const InstallationsSummary: React.FC<Props> = ({
  installations,
  isEditing = false,
  showManageButton = false,
  onManageClick,
  title,
}) => {
  return (
    <div className={styles.installationsSummary}>
      <div className={styles.summaryHeader}>
        <h4>
          {title || t('installations')} ({installations?.length || 0})
        </h4>
        {isEditing && showManageButton && onManageClick && (
          <button
            type="button"
            className={styles.manageBtn}
            onClick={onManageClick}
          >
            {t('manage_installations')}
          </button>
        )}
      </div>

      {installations?.length > 0 ? (
        <div className={styles.installationsList}>
          {installations.map((installation: Installation, index: number) => (
            <div key={index} className={styles.installationSummaryItem}>
              <span className={styles.installationName}>
                {installation.name || t('unnamed_installation')}
              </span>
              <span className={styles.installationPrice}>
                {(installation.price_without_vat ||
                  installation.priceWithoutVat) &&
                  t('currency', {
                    value:
                      parseFloat(
                        installation.price_without_vat ||
                          installation.priceWithoutVat ||
                          '0',
                      ) || 0,
                    currency: 'ILS',
                  })}
              </span>
              <span className={styles.installationType}>
                {(installation.installation_type ||
                  installation.installationType) === InstallationTypeEnum.LEASING_COMPANY
                  ? t('leasing_company')
                  : t('importer')}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.noInstallations}>
          <p>
            {isEditing && showManageButton
              ? t('no_installations_click_manage')
              : t('no_installations')}
          </p>
        </div>
      )}
    </div>
  )
}

export default InstallationsSummary
